import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import i18n from "../../i18n";
import Flag from "react-world-flags";
import { FaAngleDown } from "react-icons/fa";

// Composant pour sélectionner la langue
class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: null, // État utilisé pour gérer la redirection après le changement de langue
    };
  }

  // Fonction pour changer la langue et rediriger l'utilisateur vers la version appropriée de la page
  changeLanguage = (targetLang) => {
    // Supprimer les préfixes de langue existants dans le chemin actuel
    let oldPath = this.props.location.pathname.replace("en/", "").replace("fr/", "").replace("es/", "");

    // Utiliser Regex pour extraire le nom de la route (le chemin de l'URL sans le préfixe de langue)
    const re = new RegExp("[A-Za-zÀ-ÖØ-öø-ÿ0-9%\\-_ ]+", "g");
    const match = re.exec(oldPath);

    if (match) {
      // Récupérer le nom de la route actuel sans le préfixe
      const currentRouteName = match[0].replace(/\//g, "");
      
      // Obtenir les chemins localisés pour la langue courante et la langue cible
      const currentLocalePaths = i18n.getDataByLanguage(i18n.language).path;
      const targetLocalePaths = i18n.getDataByLanguage(targetLang).path;

      // Trouver la clé correspondant à la route actuelle
      const routeKey = Object.keys(currentLocalePaths).find((key) => currentLocalePaths[key] === currentRouteName);
      const targetRouteName = targetLocalePaths[routeKey];

      // Remplacer le nom de la route actuel par celui de la langue cible
      oldPath = oldPath.replace(currentRouteName, targetRouteName);
    }

    // Déterminer le préfixe de la langue cible (par exemple "/en" ou "/es")
    const prefix = targetLang === "en" ? "/en" : targetLang === "es" ? "/es" : "";
    const newPath = prefix + oldPath;

    // Définir l'état de redirection avec le nouveau chemin
    this.setState({
      redirect: newPath,
    });

    // Changer la langue dans le contexte de l'application
    i18n.changeLanguage(targetLang);
  };

  render() {
    const { redirect } = this.state;
    
    // Définir les options disponibles pour les langues (code, label, et texte alternatif)
    const languages = {
      fr: { code: "FR", label: "FR", alt: "Français" },
      en: { code: "US", label: "EN", alt: "English" },
      es: { code: "ES", label: "ES", alt: "Español" },
    };

    // Déterminer la langue actuelle en fonction des props
    const currentLanguage = languages[this.props.lang];

    return (
      <UncontrolledDropdown>
        {/* Gérer la redirection si nécessaire */}
        {redirect &&
          (this.props.location.search !== null ? (
            // Si l'URL contient des paramètres de requête, les conserver
            <Redirect to={{ pathname: redirect, search: this.props.location.search }} />
          ) : (
            <Redirect to={{ pathname: redirect }} />
          ))}

        {/* Bouton qui affiche la langue actuelle */}
        <DropdownToggle nav>
          {currentLanguage && (
            <>
              {/* Afficher le drapeau correspondant à la langue actuelle */}
              <Flag code={currentLanguage.code} alt={currentLanguage.alt} style={{ width: "20px", marginRight: "5px" }} />
              {currentLanguage.label}
              <FaAngleDown />
            </>
          )}
        </DropdownToggle>

        {/* Menu déroulant pour sélectionner la langue */}
        <DropdownMenu>
          {Object.keys(languages).map((key) => (
            <DropdownItem key={key} onClick={() => this.changeLanguage(key)} className="custom-dropdown-item">
              {/* Afficher le drapeau et le nom de chaque langue disponible */}
              <Flag code={languages[key].code} alt={languages[key].alt} style={{ width: "20px", marginRight: "10px" }} />
              {languages[key].alt}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}

export default withRouter(LanguageSelector);
